import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Container, Grid, Heading } from 'theme-ui'

const Spotlight = ({
  bgOverride,
  cta,
  description,
  heading,
  image,
  subtitle,
  title,
}) => {
  return (
    <Box
      bg={bgOverride || 'backgroundDark'}
      pt={[6, 7, 9]}
      pb={[7, 8, 10]}
      sx={{ overflow: 'hidden' }}
    >
      <Container sx={{ position: 'relative' }}>
        <Heading
          as="h2"
          variant="title2"
          mb={title ? [5, 7] : [3, 4]}
          sx={{ textAlign: 'center' }}
        >
          {heading}
        </Heading>
        <Grid
          columns={[1, 2, 12]}
          sx={{
            alignItems: 'center',
            gridRowGap: 5,
            position: 'relative',
            '&:before': bgOverride === 'backgroundHolidayBlue' && {
              backgroundImage: `url('/images/backgrounds/secondary-blob-left.svg')`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
              content: '""',
              display: ['none', 'block'],
              height: '1167px',
              left: [null, '-791px', '-704px', '-460px'],
              position: 'absolute',
              bottom: [null, '-500px', null, '-760px'],
              width: '1024px',
            },
          }}
        >
          <Box
            px={[null, null, 2]}
            sx={{
              gridColumn: [null, null, '2 / 7'],
            }}
          >
            <Box
              sx={{
                borderRadius: '50%',
                margin: '0 auto',
                maxWidth: '475px',
                overflow: 'hidden',
                transform: 'translateZ(0)',
              }}
            >
              <GatsbyImage
                image={image.gatsbyImageData}
                alt={image.description}
              />
            </Box>
          </Box>
          <Box sx={{ gridColumn: [null, null, '7 / 12'] }}>
            {title && (
              <Heading as="h3" variant="title3">
                {title}
              </Heading>
            )}
            {subtitle && (
              <Heading as="h4" mt={[0, 1]} mb={2} variant="subtitle2">
                {subtitle}
              </Heading>
            )}
            {description && (
              <Box
                variant="text.body2"
                sx={{
                  '& p:first-of-type': {
                    mt: 0,
                  },
                  '& p:last-of-type': {
                    mb: 0,
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
            {cta && <Box mt={[3, 4]}>{cta}</Box>}
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default Spotlight
